



















































import {Component, Prop, Vue} from 'vue-property-decorator'
import {$, Collection, ID, Resp} from 'simpli-web-sdk'
import Carga from '@/model/resource/Carga'
import Motorista from '@/model/resource/Motorista'
import * as Helper from '@/helpers'
import CargaRequest from '@/model/request/CargaRequest'
import {ItrackCollection} from '@/helpers'

@Component
export default class ModalDeliveryDriverAssociation extends Vue {
  model = new Carga()
  collection = new Collection(Carga)

  allMotorista = ItrackCollection.allMotoristaFiltro

  selectedModels: Motorista[] = []

  async associate() {
    const ids = this.collection.items.map((item) => item.$id)
    const item = this.model as Carga

    const request = new CargaRequest()
    request.ids = ids
    request.item = item

    if (this.isDisassociate()) {
      await Carga.desassociarMotoristaCarga(request as CargaRequest, 'cargaInProgress')
      Helper.success('system.success.associate')
      this.$emit('associate')
    } else {
      await Carga.associarMotoristaCarga(request as CargaRequest, 'cargaInProgress')
      Helper.success('system.success.associate')
      this.$emit('associate')
    }

    this.close()
  }

  get submitLabel() {
    return (!this.isDisassociate())
      ? 'app.associate'
      : 'app.disassociate'
  }

  isDisassociate() {
    return !this.model.motorista.$id && this.selectedModels.length
  }

  close() {
    this.$modal.close('deliveryDriverAssociation')
  }

  reset() {
    this.model = new Carga()
    this.collection.items = []
  }

  async openEvent(selectedItems: Carga[]) {
    this.$emit('open')
    this.reset()
    this.collection.items = selectedItems
    this.selectedModels = selectedItems
      .map((item) => item.motorista)
      .filter((item) => (item.nome))
    await this.allMotorista.query()

    if (this.selectedModels.length) {
      this.allMotorista.prepend(0, $.t('modal.deliveryDriverAssociation.disassociateDriver'))
    }
  }

  closeEvent() {
    this.$emit('close')
    this.reset()
  }
}
